<template>
  <sc-dropdown
    :disabled="!hasActionsMenu(row)"
    position="is-bottom-left">
    <sc-button
      theme="primary"
      slot="trigger"
      text="Ações"
      icon="caret-down" />
    <sc-dropdown-item
      v-for="action in actionsList"
      v-if="hasActionMethod(row, action.method)"
      class="has-text-left"
      :key="action.method"
      @click="executeActionMethod(row, action.method)">
      {{ action.name }}
    </sc-dropdown-item>
  </sc-dropdown>
</template>

<script>
  import {
    ScButton,
    ScDropdown,
    ScDropdownItem,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions } = createNamespacedHelpers('psl/pslList');
  export default {
    name: 'sc-actions-menu',
    props: {
      row: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        actionsList: [
          {
            name: 'Visualizar',
            method: 'viewPsl',
          },
          {
            name: 'Continuar Edição',
            method: 'editPsl',
          },
          {
            name: 'Gerar Romaneio',
            method: 'generateRomaneio',
          },
          {
            name: 'Regerar Notfis',
            method: 'resendPsl',
          },
          {
            name: 'Regerar Notfis e baixar',
            method: 'generateNotifis',
          },
          {
            name: 'Disparar PLP com os volumes selecionados',
            method: 'triggerPslForSelectedVolumes',
          },
        ],
      };
    },
    methods: {
      ...mapActions([
        'generateRomaneio',
        'resendPsl',
        'generateNotifis',
        'triggerPslForSelectedVolumes',
      ]),
      hasActionsMenu(row) {
        const {
          psl_id_in_logistic_provider = null,
          actions = {
            is_downloadable: false,
            is_resendable: false,
          },
          localized_status = false,
        } = row;
        return !(!psl_id_in_logistic_provider
          && !actions.is_downloadable && !actions.is_resendable
          && localized_status !== 'PREPARING');
      },
      hasActionMethod(row, type) {
        const {
          psl_id_in_logistic_provider = null,
          actions = {
            is_downloadable: false,
            is_resendable: false,
          },
          localized_status = null,
        } = row;
        const actionMethods = {
          generateRomaneio: !!psl_id_in_logistic_provider,
          generateNotifis: actions.is_downloadable,
          resendPsl: actions.is_resendable,
          editPsl: (localized_status === 'PREPARING'),
          viewPsl: true,
        };
        return actionMethods[type];
      },
      executeActionMethod(row, type) {
        if (!this[type]) return false;
        return this[type](row);
      },
      editPsl({ id = null }) {
        if (id) {
          this.$router.push({
            name: 'manual-dispatch-manager',
            params: {
              id,
            },
          });
        }
      },
      viewPsl({ id = null }) {
        if (id) {
          window.location.assign(`/ng#/plp/${id}/`);
        }
      },
    },
    components: {
      ScButton,
      ScDropdown,
      ScDropdownItem,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/ScActionsMenu.vue